/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUnlock: {
  name: 'unlock';
  data: string;
} = {
  name: 'unlock',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a4 4 0 0 0-4 4v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-8V6a2 2 0 1 1 4 0 1 1 0 1 0 2 0 4 4 0 0 0-4-4Zm-3 8H6v10h12V10H9Zm3 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" fill="currentColor"/></svg>`,
};
